<template>
  <div v-loading="loading"
       class="page-container labor">
    <sub-header :hideBox="true">
      <template slot="title">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name:'labors', params: {projectId:jobsiteID} }">{{($t('labor.Labor'))}}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <el-select v-model="selectLaborGroupId"
                       class="project-box"
                       filterable
                       size="mini"
                       remote
                       clear
                       @visible-change="showLaborGroupSelect"
                       :placeholder="$t('layout.SearchOrJumpTo')"
                       :remote-method="remoteMethod"
                       @change="toLaborDetail">
              <el-option v-for="i of laborGroupList"
                         :key="i.LaborGroupId"
                         :label="i.Name"
                         :value="i.LaborGroupId"></el-option>
            </el-select>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </template>
    </sub-header>
    <div class="main">
      <el-tooltip class="item"
                  effect="dark"
                  content="Edit Items"
                  placement="top">
        <div class="btn-fix"
             v-has="'Create Report'"
             @click="switchEdit"
             v-show="!edit">
          <i class="el-icon-edit"></i>
        </div>
      </el-tooltip>
      <el-tooltip class="item"
                  effect="dark"
                  content="Save"
                  placement="top">
        <div class=" btn-save"
             v-has="'Create Report'"
             @click="saveUnitCost"
             v-show="edit">
          <i class="el-icon-check"></i>
        </div>
      </el-tooltip>
      <div class="groupHeader">
        <el-form label-position="left">
          <el-row :gutter="10">
            <el-col :span="24">

              <el-form-item :label="$t('labor.Job Name:')">{{data.JobsiteName}}</el-form-item>
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('labor.Trades:')">
                    <span class="tradeSpan">{{data.TradesStr}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('labor.Retainage:')">{{data.RetainageRate}} %</el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="date-box">
                    <span style="font-size:14px;color:#909399">{{($t('labor.Time Ranges:'))}}</span>
                    <el-popover placement="bottom"
                                v-model="dateShow"
                                trigger="click">
                      <el-button slot="reference"
                                 @click="showPop"
                                 type="default"
                                 size="small"
                                 style="font-size:13px">{{data.TimeRange}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                      <div class="date-pop">
                        <div class="date-type">
                          <el-radio-group v-model="dateType"
                                          @change="changDateType()"
                                          size="small">
                            <el-radio-button label="Presets"></el-radio-button>
                            <el-radio-button label="Range"></el-radio-button>
                            <el-radio-button label="Weeks"></el-radio-button>
                            <el-radio-button label="Months"></el-radio-button>
                          </el-radio-group>
                        </div>
                        <div class="date-content">
                          <template v-if="dateType === 'Presets'">
                            <div class="Presets">
                              <div v-for="(item,index) in pickerOptions.shortcuts"
                                   :key="index"
                                   :style="{color:item.range=== rangeDate?color:''}"
                                   @click="getRanges(item.range)">
                                <span>{{item.text}}</span>
                                <span>{{item.range}}</span>
                              </div>
                            </div>
                          </template>
                          <template v-if="dateType === 'Range'">
                            <div class="range">
                              <div class="range-input">
                                <el-date-picker type="date"
                                                size="small"
                                                value-format="MM/dd/yyyy"
                                                v-model="startDate"
                                                placeholder="Start Date"
                                                @change="getStartDate"
                                                ref="start">
                                </el-date-picker>
                                -
                                <el-date-picker type="date"
                                                size="small"
                                                align="right"
                                                v-model="endDate"
                                                placeholder="End Date"
                                                @change="getEndDate"
                                                ref="end">
                                </el-date-picker>
                              </div>
                            </div>
                          </template>
                          <template v-if="dateType === 'Weeks'">
                            <div class="weeks">
                              <el-date-picker type="week"
                                              size="small"
                                              @change="getWeekDate"
                                              v-model="weekDate"
                                              format="Week WW, yy"
                                              :picker-options="{firstDayOfWeek: 1}"
                                              ref="week">
                              </el-date-picker>
                            </div>
                          </template>
                          <template v-if="dateType === 'Months'">
                            <div class="month">
                              <el-date-picker type="month"
                                              size="small"
                                              v-model="monthDate"
                                              @change="getmonthDate"
                                              ref="month">
                              </el-date-picker>
                            </div>
                          </template>
                        </div>
                        <div class="date-btn">
                          <el-button size="mini"
                                     type="primary"
                                     v-has="'Create Report'"
                                     @click="getFormTime"
                                     :disabled="save"
                                     style="float:right">Save</el-button>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="btn-box">
            <el-button type="primary"
                       v-has="'Create Report'"
                       @click="openLaborGroupDialog"
                       size="small">{{$t('labor.Edit')}}</el-button>

            <el-button type="primary"
                       v-has="'Create Report'"
                       @click="openLaborBillingReport"
                       size="small">{{$t('labor.Export PDF Report')}}</el-button>

            <el-dropdown @command="DeleteProjectLaborGroups"
                         v-has="'Create Report'"
                         trigger="click"
                         style="margin:0 10px;vertical-align: middle;cursor:pointer">
              <span class="el-dropdown-link">
                <i class="el-icon-more"
                   style="transform: rotate(90deg)"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="laborGroupId">
                  <el-link :underline="false"
                           type="danger">{{$t('group.Delete')}}</el-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-form>
      </div>
      <div class="group">
        <el-table style="100%;"
                  border
                  class="table-header"
                  empty-text=" ">
          <template slot="empty"
                    v-if="list.length === 0">
            {{$t('group.NoData')}}
          </template>
          <el-table-column min-width="150">
            <template slot="header">
              <span class="header-text">{{$t('labor.Description of Work')}}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="50">
            <template slot="header">
              <span class="header-text">{{$t('labor.Unit Cost')}}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span class="header-text"
                    style="color: #e6a23c;">{{$t('labor.Previous Billings')}}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span class="header-text"
                    style="color: #67c23a;">{{$t('labor.Current Billing')}}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span class="header-text"
                    style="color: #409eff;">{{$t('labor.Total Completed')}}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span class="header-text"
                    style="color: #f56c6c;">{{$t('labor.Uncompleted')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center"
                           width="90">>
            <template slot="header">
              <span>{{$t('labor.Retainage')}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column width="80"
                           align="center">
            <template slot="header">
              <span>{{$t('labor.Action')}}</span>
            </template>
          </el-table-column> -->
        </el-table>
        <myScroll style="width:100%;height:100%;">
          <div class="plan-box"
               v-for="item in list"
               :key="item.Planid">
            <h3 class="plan-name">{{item.PlanName}}</h3>
            <el-table :data="item.Items"
                      border
                      :show-header="false"
                      class="table"
                      style="100%;"
                      size="small">
              <el-table-column header-align="center"
                               min-width="150">
                <template slot-scope="scope">
                  <div class="sku">{{scope.row.DescriptionOfWork.SKU}}</div>
                  <div class="tag-box-big">
                    <span>${{$config.numberFormat(scope.row.ContractAmount)}} ({{$config.numberFormat(scope.row.DescriptionOfWork.Amount)}} {{scope.row.DescriptionOfWork.Unit}} X ${{$config.numberFormat(scope.row.DescriptionOfWork.UnitCost)}})</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center"
                               min-width="50">
                <template slot-scope="scope">
                  <template v-if="!edit">
                    <span> ${{$config.numberFormat(scope.row.DescriptionOfWork.UnitCost)}} </span>
                  </template>
                  <template v-if="edit">
                    <div class="edit-box-table">
                      <span>
                        $
                      </span>
                      <el-input size="small"
                                v-model="scope.row.DescriptionOfWork.UnitCost"
                                @change="unitCostChange(scope.row.DescriptionOfWork)">
                      </el-input>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column header-align="center">
                <template slot-scope="scope">
                  <div class="tag-box">
                    <span type="primary">${{scope.row.PreviousBillings.Amount?$config.numberFormat(scope.row.PreviousBillings.Amount):'0'}}</span>
                    <span type="primary"
                          style="color:#F56C6C">{{scope.row.PreviousBillings.showRate}}%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center">
                <template slot-scope="scope">
                  <div class="tag-box">
                    <span type="success"
                          size="small">{{$config.numberFormat(scope.row.CurrentWorkBilling.InstalledAmount)}} {{scope.row.DescriptionOfWork.Unit}}</span>
                    <span type="success"
                          size="small">${{$config.numberFormat(scope.row.CurrentWorkBilling.BillingPeriod)}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center">
                <template slot-scope="scope">
                  <div class="tag-box">
                    <span type="primary">${{$config.numberFormat(scope.row.TotalCompletedWork.CompletedToDate)}}</span>
                    <span type="primary"
                          style="color:#F56C6C">{{scope.row.TotalCompletedWork.showRate}}%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center">
                <template slot-scope="scope">
                  <div class="tag-box">
                    <span type="danger">{{$config.numberFormat(scope.row.UnCompletedWork.UnInstalledMat)}} {{scope.row.DescriptionOfWork.Unit}}</span>
                    <span type="danger">${{$config.numberFormat(scope.row.UnCompletedWork.BalanceToFinish)}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Retainage"
                               align="center"
                               width="90">
                <template slot-scope="scope">
                  ${{$config.numberFormat(scope.row.Retainage)}}
                </template>
              </el-table-column>
              <!-- <el-table-column label="Action"
                               align="center"
                               width="80">
                <template slot-scope="scope">
                  <el-tooltip class="item"
                              effect="dark"
                              :content="$t('corp.Edit')"
                              placement="bottom">
                    <el-button size="mini"
                               @click="openLineDialog(scope.row,item.LinkProjectId)"
                               type="success"
                               circle
                               icon="el-icon-edit"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div class="groupSub">
            <div class="sub-box">
              <div class="sub-box-text">
                <div class="left">{{$t('labor.Previous Billings:')}}</div>
                <div class="right">${{$config.numberFormat(subList.PreviousBillingsAmount)}}</div>
              </div>
              <div class="sub-box-text">
                <div class="left">{{$t('labor.Current Billing:')}}</div>
                <div class="right">${{$config.numberFormat(subList.BillingPeriod)}}</div>
              </div>
              <div class="sub-box-text">
                <div class="left">{{$t('labor.Total Completed:')}}</div>
                <div class="right">${{$config.numberFormat(subList.CompletedToDate)}}</div>
              </div>
              <div class="sub-box-text">
                <div class="left">{{$t('labor.Uncompleted:')}}</div>
                <div class="right">${{$config.numberFormat(subList.BalanceToFinish)}}</div>
              </div>
              <div class="sub-box-text">
                <div class="left">{{$t('labor.Retainage:')}}</div>
                <div class="right">${{$config.numberFormat(subList.Retainage)}}</div>
              </div>
              <div class="sub-box-text bg">
                <div class="left">{{$t('labor.Sub Totals:')}}</div>
                <div class="right">${{$config.numberFormat(subList.ContractAmount)}}</div>
              </div>
            </div>
          </div>
        </myScroll>
      </div>
    </div>
    <laborGroupDialog :showDialog="laborGroupDialog.showDialog"
                      :editForm="laborGroupDialog.editForm"
                      @closeDialog="closeLaborGroupDialog"></laborGroupDialog>
    <div style="display:none;">
      <addLaborBillingReport :showDialog="addLaborBillingReport.showDialog"
                             :reportHeaderData="addLaborBillingReport.reportHeaderData"
                             :laborDatas="addLaborBillingReport.laborDatas"
                             :subTotalData="addLaborBillingReport.subTotalData"
                             @closeDialog="closeLaborBillingReport"></addLaborBillingReport>
    </div>
    <pdfPreview :showDialog="pdfPreview.show"
                :pdfFileName="pdfPreview.name"
                :url="pdfPreview.url"
                :showSendMail="pdfPreview.showSendMail"
                :id="pdfPreview.id"
                @closeDialog="handlePdfPreview"
                @openSendMailDialog="openSendMailDialog">
    </pdfPreview>
    <sendMailDialog :showDialog="sendMailDialog.show"
                    :fileName="sendMailDialog.name"
                    :id="sendMailDialog.id"
                    @closeDialog="handleSendMail">
    </sendMailDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  ProjectLaborEstimations,
  DeleteProjectLaborGroups,
  PostProjectProductDatas,
  PostProjectLaborGroups,
  GetProjectLaborGroups
} from '@/api/config'
import moment from 'moment'
import axios from 'axios'
import laborGroupDialog from '@/components/labor/laborGroupDialog.vue'
import addLaborBillingReport from '@/components/labor/addLaborBillingReport.vue'
import pdfPreview from '@/components/pdf/pdfPreview.vue'
import sendMailDialog from '@/components/report/sendMailDialog.vue'
moment.locale('zh-cn')
export default {
  components: {
    laborGroupDialog,
    addLaborBillingReport,
    pdfPreview,
    sendMailDialog
  },
  data () {
    return {
      save: false,
      color: '#4193f6',
      rangeDate: '',
      monthDate: '',
      weekDate: '',
      startDate: '',
      endDate: '',
      dateShow: false,
      pickerOptions: {
        shortcuts: [
          {
            text: 'Last Week',
            range: (moment().week(moment().week() - 1).startOf('week').format('MM/DD/yyyy')) + ' - ' + moment().week(moment().week() - 1).endOf('week').format('MM/DD/yyyy'),
            startDate: moment().week(moment().week() - 1).startOf('week').format('MM/DD/yyyy'),
            endDate: moment().week(moment().week() - 1).endOf('week').format('MM/DD/yyyy')
          },
          {
            text: 'Last Month',
            range: (moment().month(moment().month() - 1).startOf('month').format('MM/DD/yyyy')) + ' - ' + moment().month(moment().month() - 1).endOf('month').format('MM/DD/yyyy'),
            startDate: moment().month(moment().month() - 1).startOf('month').format('MM/DD/yyyy'),
            endDate: moment().month(moment().month() - 1).endOf('month').format('MM/DD/yyyy')
          },
          {
            text: 'Last 7 Days',
            range: (moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('MM/DD/yyyy')) + ' - ' + moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy'),
            startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format('MM/DD/yyyy'),
            endDate: moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy')
          },
          {
            text: 'Last 30 Days',
            range: (moment(new Date().getTime() - 3600 * 1000 * 24 * 30).format('MM/DD/yyyy ')) + ' - ' + moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy'),
            startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 30).format('MM/DD/yyyy'),
            endDate: moment(new Date() - 3600 * 1000 * 24).format('MM/DD/yyyy')
          },
          {
            text: 'Last 90 Days ',
            range: (moment(new Date().getTime() - 3600 * 1000 * 24 * 90).format('MM/DD/yyyy ')) + ' - ' + moment(new Date().getTime() - 3600 * 1000 * 24).format('MM/DD/yyyy'),
            startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 90).format('MM/DD/yyyy'),
            endDate: moment(new Date() - 3600 * 1000 * 24).format('MM/DD/yyyy')
          }
        ]
      },
      timeRanges: [],
      dateType: 'Presets',
      edit: false,
      visible: false,
      loading: false,
      data: {
      },
      list: [],
      subList: {},
      laborGroupDialog: {
        showDialog: false,
        editForm: {}
      },
      lineDialog: {
        showDialog: false
      },
      lineForm: {},
      btnLoading: false,
      addLaborBillingReport: {
        showDialog: false,
        reportHeaderData: {},
        laborDatas: [],
        subTotalData: {}
      },
      pdfPreview: {
        show: false,
        name: '',
        url: '',
        id: '',
        showSendMail: false
      },
      sendMailDialog: {
        show: false,
        name: '',
        id: ''
      },
      condition: {
        JobsiteId: '',
        Name: '',
        PageIndex: 1,
        PageSize: 10
      },
      selectLaborGroupId: this.$route.params.laborGroupId,
      laborGroupList: []
    }
  },
  created () {

  },
  computed: {
    ...mapState(['jobsiteID']),
    laborGroupId () {
      return this.$route.params.laborGroupId
    }
  },
  mounted () {
    this.GetProjectLaborGroups()
    this.ProjectLaborEstimations()
  },
  methods: {
    getFormTime () {
      this.timeRanges = []
      if (this.dateType === 'Presets') {
        this.timeRanges = this.rangeDate.split('-')
      }
      if (this.dateType === 'Range') {
        this.timeRanges.push(this.startDate)
        this.timeRanges.push(this.endDate)
      }
      if (this.dateType === 'Weeks') {
        var date = moment(this.weekDate)
        var dow = date.day()
        var monday = date.subtract(dow - 1, 'days').format('MM/DD/yyyy')// 本周一
        var sunday = moment(monday).subtract(-6, 'days').format('MM/DD/yyyy')// 本周日
        this.timeRanges.push(monday)
        this.timeRanges.push(sunday)
      }
      if (this.dateType === 'Months') {
        var date1 = moment(this.monthDate).startOf('month').format('MM/DD/yyyy')
        var date2 = moment(this.monthDate).endOf('month').format('MM/DD/yyyy')
        this.timeRanges.push(date1)
        this.timeRanges.push(date2)
      }
      if (this.timeRanges[0] === '') {
        this.timeRanges = []
        this.timeRanges.push(this.data.showStartDate.substring(0, 10))
        this.timeRanges.push(this.data.showEndDate.substring(0, 10))
      }
      this.dateShow = false
      this.showTime()
    },
    showPop () {
      this.dateType = 'Presets'
      this.timeRanges = []
    },
    getRanges (value) {
      this.rangeDate = value
    },
    getEndDate () {
      this.$refs.end.$refs.reference.$refs.input.focus()
    },
    getStartDate () {
      this.$refs.end.$refs.reference.$refs.input.focus()
    },
    getmonthDate () {
      this.$refs.month.$refs.reference.$refs.input.focus()
    },
    getWeekDate () {
      this.$refs.week.$refs.reference.$refs.input.focus()
    },
    changDateType () {
      if (this.dateType === 'Weeks') {
        this.$refs.week.$refs.reference.$refs.input.focus()
      }
      if (this.dateType === 'Months') {
        this.$refs.month.$refs.reference.$refs.input.focus()
      }
      if (this.dateType === 'Range') {
        this.$refs.start.$refs.reference.$refs.input.focus()
      }
    },
    unitCostChange (row) {
      for (let i of this.list) {
        for (let j of i.Items) {
          if (j.DescriptionOfWork.SKU === row.SKU) {
            j.DescriptionOfWork.UnitCost = row.UnitCost
          }
        }
      }
    },
    showTime () {
      let data = {
        LaborGroupId: this.data.LaborGroupId,
        CorpId: this.data.CorpId,
        JobsiteId: this.data.JobsiteId,
        JobsiteName: this.data.JobsiteName,
        Name: this.data.Name,
        SubContract: this.data.SubContract,
        SubContLocation: this.data.SubContLocation,
        SubContPONumber: this.data.SubContPONumber,
        JobNumber: this.data.JobNumber,
        ApplicationNumber: this.data.ApplicationNumber,
        ApplicationDate: this.data.ApplicationDate ? this.data.ApplicationDate : null,
        PayPeriodEnding: this.data.PayPeriodEnding ? this.data.PayPeriodEnding : null,
        RetainageRate: this.data.RetainageRate * 1,
        IsDeleted: false,
        Trades: this.data.Trades,
        EndDate: this.timeRanges[1],
        StartDate: this.timeRanges[0]
      }
      let pass = data
      pass.JobsiteId = this.jobsiteID
      pass.CorpId = this.corpId
      pass.RetainageRate = this.$config.divide(this.data.RetainageRate, 100).toFixed(4)
      pass.StartDate = this.$config.UTCTime(pass.StartDate, false, true)
      pass.EndDate = this.$config.UTCTime(pass.EndDate, false, true)
      let array = []
      array.push(pass)
      PostProjectLaborGroups(array).then(res => {
        this.ProjectLaborEstimations()
      })
    },
    switchEdit () {
      this.edit = true
    },
    DeleteProjectLaborGroups (id) {
      let params = []
      params.push(id)
      this.$confirm(this.$t('labor.Are you sure you want to delete this labor group?'), 'TIPS', {
        confirmButtonText: this.$t('corp.Yes'),
        cancelButtonText: this.$t('corp.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        DeleteProjectLaborGroups(params).then(res => {
          this.$router.push({
            name: 'labors'
          })
        })
      })
    },
    openLaborGroupDialog () {
      let data = {
        LaborGroupId: this.data.LaborGroupId,
        CorpId: this.data.CorpId,
        JobsiteId: this.data.JobsiteId,
        Name: this.data.Name,
        SubContract: this.data.SubContract,
        SubContLocation: this.data.SubContLocation,
        SubContPONumber: this.data.SubContPONumber,
        JobNumber: this.data.JobNumber,
        ApplicationNumber: this.data.ApplicationNumber,
        ApplicationDate: this.data.ApplicationDate ? this.data.ApplicationDate : null,
        PayPeriodEnding: this.data.PayPeriodEnding ? this.data.PayPeriodEnding : null,
        RetainageRate: this.data.RetainageRate * 1,
        IsDeleted: false,
        Trades: this.data.Trades,
        timeRanges: [this.data.StartDate, this.data.EndDate],
        StartDate: moment(this.data.StartDate).format('MM/DD/yyyy '),
        EndDate: moment(this.data.EndDate).format('MM/DD/yyyy ')
      }
      this.laborGroupDialog.editForm = data
      this.laborGroupDialog.showDialog = true
    },
    closeLaborGroupDialog (type) {
      if (type === 'save') {
        this.ProjectLaborEstimations()
      }
      this.laborGroupDialog.showDialog = false
    },
    saveUnitCost () {
      this.loading = true
      let array = []
      for (let i of this.list) {
        for (let j of i.Items) {
          let pass = {
            DataId: j.DataId,
            JobsiteId: this.jobsiteID,
            ProjectId: i.LinkProjectId,
            SKU: j.DescriptionOfWork.SKU,
            UnitCost: j.DescriptionOfWork.UnitCost,
            ProductId: j.ProductId,
            NonM2Product: j.NonM2Product
          }
          array.push(pass)
        }
      }
      PostProjectProductDatas(array).then(res => {
        this.edit = false
        this.ProjectLaborEstimations()
      })
    },
    ProjectLaborEstimations () {
      this.visible = false
      this.subList = []
      this.loading = true
      // let pass = {
      //   id: this.laborGroupId
      // }
      ProjectLaborEstimations(this.selectLaborGroupId).then(res => {
        this.data = res
        this.data.ApplicationDate = this.$config.LocalTime(this.data.ApplicationDate)
        this.data.StartDate = this.$config.LocalTime(this.data.StartDate)
        this.data.EndDate = this.$config.LocalTime(this.data.EndDate)
        console.log(this.data.EndDate)
        this.data.ApplicationDate = this.data.ApplicationDate ? moment(this.data.ApplicationDate).format('MM/DD/yyyy ') : ''
        this.data.PayPeriodEnding = this.data.PayPeriodEnding ? moment(this.data.PayPeriodEnding).format('MM/DD/yyyy ') : ''
        this.data.RetainageRate = this.$config.multiply(this.data.RetainageRate, 100)
        this.data.showStartDate = moment(this.data.StartDate).format('MM/DD/yyyy hh:mm:ss')
        this.data.showEndDate = moment(this.data.EndDate).format('MM/DD/yyyy hh:mm:ss')
        this.data.TimeRange = this.data.showStartDate.substring(0, 10) + ' - ' + this.data.showEndDate.substring(0, 10)
        this.data.TradesStr = this.data.Trades.join(', ')
        if (this.data.TradesStr === 'OPTION_ALL') {
          this.data.TradesStr = this.$t('labor.All')
        }
        this.list = res.PlanLaborDatas
        for (let i of this.list) {
          if (i.PlanId.length === 0) {
            i.PlanName = this.$t('labor.' + i.PlanName)
          }
          for (let j of i.Items) {
            j.PreviousBillings.showRate = this.$config.multiply(j.PreviousBillings.Rate, 100)
            j.TotalCompletedWork.showRate = this.$config.multiply(j.TotalCompletedWork.Rate, 100)
          }
        }
        this.subList = res.SubTotal
        this.loading = false
        setTimeout(() => {
          if (this.list.length > 0 && document.getElementsByClassName('el-table__empty-block').length > 0) {
            document.getElementsByClassName('el-table__empty-block')[0].style.display = 'none'
          }
        }, 100)
      }).catch(() => {
        /*  if (err.response.status === 400) {
           this.$msgbox({
             message: 'The group of type BillingPeriod not found.',
             title: this.$t('corp.TIPS'),
             type: 'warning',
             showClose: false,
             confirmButtonText: 'Creat group of type BillingPeriod',
             closeOnClickModal: false,
             closeOnPressEscape: false
           }).then(() => {
             this.$router.push({
               name: 'group'
             })
           })
         } */
      })
    },
    openLaborBillingReport () {
      this.data.ApplicationDate = this.$config.LocalTime(this.data.ApplicationDate)
      this.data.StartDate = this.$config.LocalTime(this.data.StartDate)
      this.data.EndDate = this.$config.LocalTime(this.data.EndDate)
      let data = {
        LaborGroupId: this.data.LaborGroupId,
        CorpId: this.data.CorpId,
        JobsiteId: this.data.JobsiteId,
        JobsiteName: this.data.JobsiteName,
        Name: this.data.Name,
        SubContract: this.data.SubContract,
        SubContLocation: this.data.SubContLocation,
        SubContPONumber: this.data.SubContPONumber,
        JobNumber: this.data.JobNumber,
        ApplicationNumber: this.data.ApplicationNumber,
        ApplicationDate: this.data.ApplicationDate ? this.data.ApplicationDate : null,
        PayPeriodEnding: this.data.PayPeriodEnding ? this.data.PayPeriodEnding : null,
        RetainageRate: this.data.RetainageRate * 1,
        IsDeleted: false,
        Trades: this.data.Trades,
        TradesStr: this.data.Trades.join(', '),
        LaborDateRange: (this.data.StartDate ? this.$config.formatDate(new Date(this.data.StartDate), 'MM/dd/yyyy') : '') +
          ' - ' + (this.data.EndDate ? this.$config.formatDate(new Date(this.data.EndDate), 'MM/dd/yyyy') : '')
      }
      this.addLaborBillingReport.reportHeaderData = data
      if (this.addLaborBillingReport.reportHeaderData.TradesStr === 'OPTION_ALL') {
        this.addLaborBillingReport.reportHeaderData.TradesStr = this.$t('labor.All')
      }
      this.addLaborBillingReport.laborDatas = this.list
      this.addLaborBillingReport.subTotalData = this.subList
      this.addLaborBillingReport.showDialog = true
    },
    closeLaborBillingReport () {
      this.addLaborBillingReport.showDialog = false
      this.addLaborBillingReport.reportHeaderData = {}
      this.addLaborBillingReport.laborDatas = []
      this.addLaborBillingReport.subTotalData = {}
    },
    previewReport (id, name) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios({
        method: 'get',
        url: this.$config.baseURL + '/api/TaskReports/' + id + '/download?',
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res], {
          type: `application/pdf`
        })
        let objectUrl = URL.createObjectURL(blob)
        this.pdfPreview.show = true
        this.pdfPreview.name = name + '.pdf'
        this.pdfPreview.url = objectUrl
        this.pdfPreview.id = id
        this.pdfPreview.showSendMail = true
      })
      loading.close()
    },
    handlePdfPreview (val) {
      this.pdfPreview.show = false
      this.pdfPreview.name = ''
      this.pdfPreview.url = ''
    },
    openSendMailDialog (id, name) {
      this.sendMailDialog.show = true
      this.sendMailDialog.name = name
      this.sendMailDialog.id = id
    },
    handleSendMail (val) {
      this.sendMailDialog.show = false
      this.sendMailDialog.name = ''
      this.sendMailDialog.id = ''
    },
    GetProjectLaborGroups () {
      this.condition.JobsiteId = this.jobsiteID
      GetProjectLaborGroups(this.condition).then(res => {
        this.laborGroupList = res.Data
      })
    },
    showLaborGroupSelect (e) {
      if (!e) {
        this.condition.Name = null
        this.GetProjectLaborGroups()
      }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.condition.Name = query
        this.GetProjectLaborGroups()
      }
    },
    toLaborDetail () {
      this.$router.push({
        name: 'labor',
        params: {
          laborGroupId: this.selectLaborGroupId
        }
      })
      this.ProjectLaborEstimations()
    }
  }
}
</script>
<style lang="scss">
.labor {
  .el-breadcrumb {
    line-height: 28px;
    float: none;
    font-size: 18px;
    vertical-align: middle;
  }
}
.groupHeader {
  .el-form-item {
    margin-bottom: 0;
    &:first-child {
      margin-top: 0;
      padding-top: 0;
    }
    .el-form-item__label {
      color: #909399;
      line-height: 32px;
      padding-right: 12px;
    }
    .el-form-item__content {
      line-height: 32px;
      height: 32px;
    }
  }
  .table-header {
    width: calc(100vw - 256px);
    .el-table__body-wrapper {
      display: none;
    }
  }
}
.date-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  span:first-child {
    display: block;
    margin-right: 12px;
  }
  .el-button--small.is-round {
    padding: 9px 1px 9px 15px;
  }
}
.date-pop {
  .date-type {
    margin: 0 auto 20px;
    text-align: center;
  }
  .date-content {
    .Presets {
      display: flex;
      flex-direction: column;
      width: 324px;
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 15px;
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
    }
    .weeks {
      width: 324px;
      height: 386px;
      .el-input {
        width: 100%;
      }
    }
    .month {
      width: 324px;
      height: 300px;
      .el-input {
        width: 100%;
      }
    }
    .range {
      width: 324px;
      height: 386px;
      .range-input {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .el-input {
          width: 45%;
        }
      }
    }
  }
  .date-btn {
    margin-top: 10px;
  }
}
</style>
<style scoped lang="scss">
.main {
  height: calc(100vh - 105px);
  position: relative;
  overflow: hidden;
  width: 100%;
  .btn-fix {
    position: fixed;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: linear-gradient(229deg, #57bafe 0%, #399fff 100%);
    box-shadow: 0px 1px 5px 0px rgba(76, 176, 255, 0.6);
    text-align: center;
    line-height: 55px;
    color: #fff;
    font-size: 32px;
    right: 20px;
    bottom: 20px;
    z-index: 100;
    cursor: pointer;
  }
  .edit-box-table {
    display: flex;
    align-items: center;
    span {
      margin-right: 5px;
    }
  }
  .btn-save {
    position: fixed;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: linear-gradient(229deg, #32e4b7 0%, #0fd5af 100%);
    box-shadow: 0px 1px 5px 0px rgba(50, 228, 183, 0.6);
    text-align: center;
    line-height: 55px;
    color: #fff;
    font-size: 32px;
    right: 20px;
    bottom: 20px;
    z-index: 100;
    cursor: pointer;
  }
  .groupHeader {
    height: 120px;
    overflow: hidden;
    background-color: #fff;
    margin: 0 8px;
    position: relative;
    padding: 8px 15px;
    box-sizing: border-box;
    .btn-box {
      position: absolute;
      right: 8px;
      top: 8px;
    }
    .edit-box {
      position: absolute;
      right: 8px;
      bottom: 8px;
    }
  }
  .group {
    height: calc(100% - 120px);
    padding: 8px;
    overflow: hidden;
    box-sizing: border-box;
    .header-text {
      text-align: center;
      display: block;
      width: 100%;
    }
    .plan-box {
      position: relative;
      overflow: hidden;
      width: calc(100vw - 196px);
      h3 {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .tag-box-big {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        span {
          display: block;
          font-size: 12px;
        }
      }
      .sku {
        border-bottom: 1px #ddd solid;
        overflow: hidden;
        font-size: 14px;
        color: #000;
      }
      .tag-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        span {
          display: block;
          width: 50%;
          text-align: center;
        }
      }
    }
    .groupSub {
      height: 250px;
      background-color: #fff;
      position: relative;
      margin-bottom: 30px;
      margin-top: 30px;
      .sub-box {
        position: absolute;
        right: 10px;
        top: 10px;
        line-height: 25px;
        width: 25%;
        font-size: 15px;
        .bg {
          font-size: 20px;
        }
        .sub-box-text {
          width: 100%;
          overflow: hidden;
          .left {
            width: 50%;
            float: left;
            color: #909399;
            text-align: left;
          }
          .right {
            margin-left: 50%;
            text-align: right;
            margin-right: 20px;
          }
        }
      }
    }
  }
  .range {
    cursor: pointer;
  }

  .tradeSpan {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 240px;
    display: inline-block;
  }
}
</style>
